import { Link } from 'react-router';

/**
 * Pied de page légal.
 *
 * ── Pourquoi il doit être VISIBLE, et pas seulement exister ─────────────────
 * Les mentions légales et les conditions de vente sont obligatoires pour un
 * service vendu en ligne, mais l'obligation ne porte pas seulement sur leur
 * existence : elles doivent être accessibles depuis les pages où l'on décide
 * d'acheter. Un lien enfoui dans un écran de réglages ne remplit pas cette
 * condition.
 *
 * D'où sa présence sur les pages PUBLIQUES — offres, inscription, connexion —
 * celles que voit quelqu'un qui n'a pas encore de compte.
 */

const LIENS = [
  // En tête : c'est le seul lien du pied de page dont on ait besoin en
  // urgence. Les trois autres se consultent, celui-ci se cherche.
  { vers: '/contact', libelle: 'Nous contacter' },
  // Consultable sans compte : c'est ce qu'on lit pour décider.
  { vers: '/documentation', libelle: 'Documentation' },
  { vers: '/mentions-legales', libelle: 'Mentions légales' },
  { vers: '/cgv', libelle: 'Conditions générales' },
  { vers: '/confidentialite', libelle: 'Données personnelles' },
] as const;

export function PiedDePage() {
  return (
    <footer className="mt-16 border-t border-[var(--color-border)] pt-6 pb-2">
      <nav className="flex flex-wrap items-center gap-x-5 gap-y-2">
        {LIENS.map((l) => (
          <Link
            key={l.vers}
            to={l.vers}
            className={[
              'text-[13px] text-[var(--color-fg-muted)] hover:text-[var(--color-fg)]',
              'focus-visible:outline-2 focus-visible:outline-offset-2',
              'focus-visible:outline-[var(--color-focus)] rounded',
            ].join(' ')}
          >
            {l.libelle}
          </Link>
        ))}
      </nav>
    </footer>
  );
}
